/** What the queue's row click puts in router state so the detail can step through the page. */
export interface TicketQueueRouteState {
	queueIds: number[];
}

export const toQueueRouteState = (rows: readonly { id: number }[]): TicketQueueRouteState => ({
	queueIds: rows.map((row) => row.id),
});

/**
 * The ids from `location.state`, or none — a direct link, a notification deep link and the
 * other-tickets list carry no state, and then the arrows stay hidden (decision 4).
 */
export const readQueueIds = (state: unknown): number[] => {
	const ids = (state as { queueIds?: unknown } | null | undefined)?.queueIds;

	return Array.isArray(ids) && ids.every((id) => typeof id === "number") ? ids : [];
};

export interface TicketNeighbours {
	previous: number | null;
	next: number | null;
}

/** The ids before and after `id` on the queue page; null at either end or off the page. */
export const ticketNeighbours = (ids: readonly number[], id: number): TicketNeighbours => {
	const index = ids.indexOf(id);

	if (index === -1) {
		return { previous: null, next: null };
	}

	return { previous: ids[index - 1] ?? null, next: ids[index + 1] ?? null };
};
